import { EditIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Container,
  Divider,
  Flex,
  IconButton,
  Image,
  Spinner,
  Text,
  Wrap,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import AddEditClientModal from "./Admin/AddEditClientModal";
import { useData } from "../Contexts/DataContext";
import { useAuth } from "../Contexts/AuthContext";

function Clients() {
  const navigate = useNavigate();

  // ✅ Use context values
  const { clients } = useData();
  const { isAdmin } = useAuth(); // loading state comes from AuthContext

  const [isAddClientModalOpen, setIsAddClientModalOpen] = useState(false);
  const [clientToEdit, setClientToEdit] = useState(null);

  const handleCloseAddClientModal = () => {
    setIsAddClientModalOpen(false);
    setClientToEdit(null);
  };

  const handleEditClient = (event, client) => {
    event.preventDefault();
    event.stopPropagation();
    setClientToEdit(client);
    setIsAddClientModalOpen(true);
  };

  return (
    <Container p={5} maxW={"container.2xl"}>
      <Flex direction="column" align="center">
        <Wrap p={2} justify="center" spacing={6}>
          {clients.length > 0 ? (
            clients.map((client) => (
              <Box
                key={client.id}
                p={5}
                shadow="md"
                borderWidth="1px"
                width="400px"
                borderRadius="md"
                cursor="default"
                position="relative"
                bg="white"
              >
                {isAdmin && (
                  <IconButton
                    icon={<EditIcon />}
                    position="absolute"
                    left="90%"
                    top="5%"
                    size="sm"
                    color="blue.700"
                    onClick={(e) => handleEditClient(e, client)}
                  />
                )}

                {client.logo && (
                  <Image
                    src={client.logo}
                    alt={`Logo of ${client.name}`}
                    height="30px"
                  />
                )}

                <Text mt={2} fontSize="xl" fontWeight="bold">
                  {client.name}
                </Text>

                <Divider my={2} />

                <Flex direction="column" fontSize="sm" gap={1}>
                  <Text>
                    <strong>Abbreviation:</strong>{" "}
                    {client.abbreviation || "N/A"}
                  </Text>
                  <Text>
                    <strong>Tenant ID:</strong> {client.tenantId || "N/A"}
                  </Text>
                  <Text>
                    <strong>Contact:</strong> {client.contactName}
                  </Text>
                  <Text>
                    <strong>Email:</strong> {client.email}
                  </Text>
                </Flex>

                <Button
                  mt={4}
                  colorScheme="blue"
                  variant="solid"
                  width="full"
                  onClick={() =>
                    navigate(`/client-portal?ctid=${client.clientId}`)
                  }
                >
                  Continue
                </Button>
              </Box>
            ))
          ) : (
            <Text>No clients available.</Text>
          )}
        </Wrap>

        {/* Admin-only modal for add/edit */}
        {isAdmin && isAddClientModalOpen && (
          <AddEditClientModal
            isOpen={isAddClientModalOpen}
            onClose={handleCloseAddClientModal}
            client={clientToEdit}
          />
        )}
      </Flex>
    </Container>
  );
}

export default Clients;
